import { SCHEDULER } from '../../../../utils/ServiceUtils';
import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IGetTaskRequest extends IBaseRequest {
    ident: string;
    userId: string;
}

export class GetTaskRequest extends BaseRequest implements IGetTaskRequest {
    public ident: string;
    public userId: string;

  constructor(server: string, session: string, ident: string, userId: string) {
    super(server, session);
    this.ident = ident;
    this.userId = userId;
  }

  public toXml(): string {
    var parameters: string = super.toXml();

    parameters += this.makeNode(this.ident, 'ident');
    parameters += this.makeNode(this.userId, 'userId');

    return super.wrapperXml(SCHEDULER.getTask, parameters);
  }
}
